export default __webpack_public_path__ + "static/media/close.341294ac.svg";